import Carousel from "react-bootstrap/Carousel";
import IMG1 from "./imgthree.jpg";
import IMG2 from "./imgone.jpg";
import IMG3 from "./img1.jpg";
import "./Home.css";
import SEO from "../../SEO";
import HomePageContent from "./HomePageContent";

const HomePage = () => {
  return (
    <div className="carousel-container">
      <SEO
        title="Spas in Pune | Home Massage Services in Pune"
        description="Looking for the best relaxing Spas in Pune? Then your search ends here! Visit
us for affordable spa and massage services at home in Pune. Book your
session!"
        keywords="spa, massage, therapy, wellness"
        canonical ="https://shrikrishnaarogyammassagestherapy.com"
      />
      <Carousel data-bs-theme="dark">
        <Carousel.Item>
          <img className="d-block w-100" src={IMG1} alt="Tranquility" />
          <Carousel.Caption>
            <h5 className="display-4 fw-bold text-muted bg-transpernt p-3 rounded HPHeader">
            Experience serenity
            </h5>
            <p className="lead fw-normal text-white HPPara">
            Our spa treatments are tailored to fulfill your requirements, and to offer you relaxation and comfort. Say goodbye to stress and discomfort.

            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src={IMG2} alt="Luxury" />
          <Carousel.Caption>
            <h5 className="display-4 fw-bold text-muted bg-transpernt p-3 rounded HPHeader">
            Luxurious de-stressing
            </h5>
            <p className="lead fw-normal text-white HPPara">
            Treat yourself to the personalized de-stressing packages that include spa treatments and rejuvenating massage therapies. Take a break from daily hustle, and indulge in our specialized services.
            </p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src={IMG3} alt="Couple's Retreat" />
          <Carousel.Caption>
            <h5 className="display-4 fw-bold text-muted bg-transpernt p-3 rounded HPHeader">
            Couple's getaway
            </h5>
            <p className="lead fw-normal text-white HPPara">
            Our customized couples massage therapy package not only rejuvenates the body but also strengthens the connection between the two. Spend peaceful moments with your partner while being pampered.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    <div>
      <HomePageContent/>
    </div>
      
    </div>
  );
};

export default HomePage;
